import _throttle from 'lodash/throttle'

export const shadowForLastColumn = {
  data() {
    return {
      isShadowForLastColumn: false,
      tableEl: null,
      resizeObserver: null
    }
  },

  methods: {
    checkHeightElementAndChangeIsShadow: _throttle(function () {
      this.isShadowForLastColumn =
        this.tableEl && this.tableEl.offsetHeight !== this.tableEl.clientHeight ? true : false
    }, 500)
  },

  mounted() {
    this.tableEl = document.querySelector('.shadow-for-last-column')
    this.tableEl && this.checkHeightElementAndChangeIsShadow()
    this.resizeObserver = new ResizeObserver(this.checkHeightElementAndChangeIsShadow)
    this.tableEl && this.resizeObserver.observe(this.tableEl)
  },

  destroyed() {
    this.tableEl && this.resizeObserver.unobserve(this.tableEl)
  }
}
